import { render, staticRenderFns } from "./checkQuestion.vue?vue&type=template&id=b875e968&scoped=true&"
import script from "./checkQuestion.vue?vue&type=script&lang=js&"
export * from "./checkQuestion.vue?vue&type=script&lang=js&"
import style0 from "./checkQuestion.vue?vue&type=style&index=0&id=b875e968&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b875e968",
  null
  
)

export default component.exports